export default __webpack_public_path__ + "static/nintex_inactive-e253975d6c3df6031e59ea6ed60efafa.png";